var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 22.76,
    viewBox: "0 0 17.36 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VIDEO",
    transform: "translate(-1 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M18.35,22.08a.681.681,0,0,1-.67.69H1.67A.681.681,0,0,1,1,22.08V.7A.681.681,0,0,1,1.67.01H13.48c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M18.35,15.86H1v6.2a.681.681,0,0,0,.67.69H17.69a.681.681,0,0,0,.67-.69V15.87Z",
    fill: "#cc4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M13.51.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    fill: "#99badb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M4.37,20.55l.83-2.56h.63L4.65,21.27H4.1L2.92,17.99h.62l.82,2.56Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M6.8,21.26H6.23V17.98H6.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M7.5,21.26V17.98h.97a1.643,1.643,0,0,1,.6.11,1.376,1.376,0,0,1,.47.31,1.348,1.348,0,0,1,.3.49,1.868,1.868,0,0,1,.11.64v.16a1.826,1.826,0,0,1-.11.64,1.438,1.438,0,0,1-.3.49,1.245,1.245,0,0,1-.47.31,1.754,1.754,0,0,1-.62.11H7.51Zm.57-2.82V20.8h.37a1.07,1.07,0,0,0,.41-.08.7.7,0,0,0,.29-.22.819.819,0,0,0,.17-.35,2.136,2.136,0,0,0,.06-.46v-.17a1.242,1.242,0,0,0-.23-.81.82.82,0,0,0-.67-.28h-.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M12.43,19.8H11.08v1.01h1.57v.45H10.51V17.98h2.13v.46H11.08v.91h1.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M15.74,19.71a2.007,2.007,0,0,1-.1.67,1.512,1.512,0,0,1-.28.5,1.243,1.243,0,0,1-.43.32,1.43,1.43,0,0,1-1.1,0,1.13,1.13,0,0,1-.43-.32,1.512,1.512,0,0,1-.28-.5,2.007,2.007,0,0,1-.1-.67v-.17a2.007,2.007,0,0,1,.1-.67,1.418,1.418,0,0,1,.28-.5,1.243,1.243,0,0,1,.43-.32,1.421,1.421,0,0,1,.55-.11,1.471,1.471,0,0,1,.56.11,1.13,1.13,0,0,1,.43.32,1.62,1.62,0,0,1,.28.5,2.3,2.3,0,0,1,.1.67v.17Zm-.57-.17a2.461,2.461,0,0,0-.05-.49.947.947,0,0,0-.15-.35.628.628,0,0,0-.25-.21.884.884,0,0,0-.33-.07.685.685,0,0,0-.58.28,1.032,1.032,0,0,0-.16.35,1.775,1.775,0,0,0-.06.49v.17a1.826,1.826,0,0,0,.06.49,1.032,1.032,0,0,0,.16.35.751.751,0,0,0,.25.22.725.725,0,0,0,.33.07.668.668,0,0,0,.58-.29,1.487,1.487,0,0,0,.2-.84v-.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M9.15,13.71a3.76,3.76,0,1,1,3.76-3.76A3.768,3.768,0,0,1,9.15,13.71Zm0-6.95a3.19,3.19,0,1,0,3.19,3.19A3.192,3.192,0,0,0,9.15,6.76Z",
    fill: "#cc4c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M10.42,10.1,8.65,11.28a.187.187,0,0,1-.29-.16V8.75a.19.19,0,0,1,.29-.16l1.77,1.18a.187.187,0,0,1,0,.31Z",
    fill: "#cc4c4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoColorIcon);
export default __webpack_public_path__ + "static/media/video-color-icon.e45c93b410b3dbb9612dde49b110d6c1.svg";
export { ForwardRef as ReactComponent };